import * as React from 'react';
interface MarkdownAnchorProps {
    title: string;
    href: string;
}

const MarkdownAnchor: React.FunctionComponent<MarkdownAnchorProps> = (props) => {

    return (<a
        href={props.href}
        target={'_blank'}
        title={props.title}
    >
        {props.children}
    </a>)
}

export default MarkdownAnchor